module.exports = __webpack_public_path__ + "static/img/b1.2d9bfaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/b1.jpg
// module id = esA5
// module chunks = 0